import { useCallback, useEffect, useRef } from 'react';

export const useCallbackIfMounted = (callback: (...args: readonly any[]) => void) => {
  const isMounted = useRef(true);

  const callbackRef = useRef(callback);

  callbackRef.current = callback;

  // ─────────────────────────────────────────────────────────────────

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  // ─────────────────────────────────────────────────────────────────

  return useCallback((...args: any) => {
    if (!isMounted.current) return;

    callbackRef.current?.(...args);
  }, []);
};
